import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";

import Typography from "@material-ui/core/Typography";
import Popover from "@material-ui/core/Popover";

import styled from "styled-components";
import * as R from "ramda";

const styles = theme => ({
  h3: {
    textAlign: "center",
    paddingLeft: "1rem",
    paddingRight: "1rem"
  },
  typography: {
    margin: theme.spacing.unit * 2
  }
});

const StyledSpan = styled.span({
  fontSize: "11px"
});
const StyledRow = styled(Typography)({
  padding: "5px"
});
const Column = styled.div(props => ({
  display: "flex",
  flexDirection: "column",
  // width: '33%',
  backgroundColor: props.color,
  // border: '1px solid #ffffff',
  textAlign: "center"
}));

class SimplePopover extends React.Component {
  state = {
    anchorEl: null
  };

  buildItemLIme = (itemName, item) => {
    return (
      <React.Fragment key={`spfr_${item.id}`}>
        {!R.isNil(itemName) ? R.prop(itemName, item) : item.model}
        {/* - Number:{" "}
        {item.id} */}
        <br />
      </React.Fragment>
    );
  };

  handleClick = event => {
    this.setState({
      anchorEl: event.currentTarget
    });
  };

  handleClose = () => {
    this.setState({
      anchorEl: null
    });
  };

  render() {
    const { classes, items, itemText, key, itemName, showNumber } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    if (R.length(items) > 0) {
      return (
        <Column key={`${key}_c`}>
          <this.props.iconImage
            aria-owns={open ? "simple-popper" : undefined}
            aria-haspopup="true"
            variant="contained"
            onClick={this.handleClick}
            style={{ color: "black", width: "20px" }}
          />{" "}
          {showNumber === "1" ? (
            <StyledSpan>({R.head(items).id})</StyledSpan>
          ) : (
            ""
          )}
          <Popover
            id="simple-popper"
            key={`${key}_p`}
            open={open}
            anchorEl={anchorEl}
            onClose={this.handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center"
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center"
            }}
          >
            <h3 className={classes.h3}>{itemText}</h3>
            {!R.isNil(R.prop("client_first_name", R.head(items))) && (
              <StyledRow className={classes.typogrzaphy}>
                {R.map(R.curry(this.buildItemLIme)(itemName), items)}
              </StyledRow>
            )}
            {!R.isNil(R.prop("model", R.head(items))) && (
              <StyledRow className={classes.typogrzaphy}>
                {R.map(R.curry(this.buildItemLIme)(null), items)}
              </StyledRow>
            )}
          </Popover>
        </Column>
      );
    }
    return null;
  }
}

SimplePopover.propTypes = {
  classes: PropTypes.object.isRequired,
  key: PropTypes.string,
  showNumber: PropTypes.any,
  itemName: PropTypes.any
};

export default withStyles(styles)(SimplePopover);



// WEBPACK FOOTER //
// ./src/components/simplePopOver.js